import React from 'react';
import ContentLoader from 'react-content-loader';

const InviteDesktopSkeleton = () => {
    return (
        <ContentLoader
            data-testid="invite-desktop-skeleton"
            speed={2}
            viewBox="0 0 621 444"
            style={{
                width: '100%',
                height: '100%',
            }}
        >
            <rect x="0" y="0" rx="2" ry="2" width="100%" height="330" />
            <rect x="0" y="360" rx="2" ry="2" width="100%" height="100" />
        </ContentLoader>
    );
};


export default InviteDesktopSkeleton;
